// extracted by mini-css-extract-plugin
export default {"PdText":"QuestionForm_PdText__dp--A","Link":"QuestionForm_Link__agaD0"};